import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";

class CompleteInformationUs extends Component {
    constructor(props) {
        super();
        this.state = {
            rfcReadOnly:false,
            readOnlyFiscalName:false,
            rfc:'',
            name:'',
            adress:'',
            fiscalName:'',
            zipCode:'',
            personType:'Individual',
            selectedState: '',
            municipality:'',
            InternalIdReadOnly:false,
            internalId:'',
            personTypeReadOnly:false,
        };
        this.changeMunicipality = this.changeMunicipality.bind(this)
        this.changeName = this.changeName.bind(this);
        this.changeRFC = this.changeRFC.bind(this);
        this.changeFiscalName = this.changeFiscalName.bind(this);
        this.changeAdress = this.changeAdress.bind(this);
        this.changeZipcode = this.changeZipcode.bind(this);
        this.changeState = this.changeState.bind(this);
    }

    validate = ()=> {
        this.fv.validate().then((status) => {
            if (status == 'Valid') {
                this.createPerson()
            }
        });
    }

    changePersonType = (event) => {
        this.setState({ personType: event.target.value });
    }

    changeInternalId = (event)=>{
        this.setState({ internalId: event.target.value });
    }

    changeMunicipality(event){
        this.setState({ municipality: event.target.value });
    }

    changeRFC(event){
        if(!this.state.rfcReadOnly){
            this.setState({ rfc: event.target.value.toUpperCase() });
        }
    }

    componentDidMount() {
        this.setState({name:this.props.name});
        this.props.rfc != ''  ? this.setState({rfcReadOnly:true}) : null;
        this.props.fiscalName != ''  ? this.setState({readOnlyFiscalName:true}) : null;
        this.props.internalid != ''  ? this.setState({InternalIdReadOnly:true}) : null;
        if (this.props.personType) {
            this.setState({
                personTypeReadOnly: true,
                personType: this.getPersonType(this.props.personType)
            });
        }
        this.setState({rfc:this.props.rfc});
        this.setState({internalId:this.props.internalid});
        this.props.fiscalName != ''  ? this.setState({fiscalName:this.props.fiscalName}) : null;
        this.fv = FormValidation.formValidation(KTUtil.getById('frm'), {
            fields: {
                name: {
                    validators: {
                        notEmpty: {
                            message: 'Nombre requerido'
                        },
                        stringLength: {
                            min: 4,
                            max: 200,
                            message: 'El nombre debe tener una longitud mínima de 4'
                        },
                    }
                },
                fiscal_name: {
                    validators: {
                        notEmpty: {
                            message: 'Nombre fiscal requerido'
                        },
                        stringLength: {
                            min: 4,
                            max: 200,
                            message: 'El nombre fiscal debe tener una longitud mínima de 4'
                        },
                    }
                },
                address1: {
                    validators: {
                        notEmpty: {
                            message: 'Dirección requerida'
                        },
                        stringLength: {
                            min: 4,
                            max: 200,
                            message: 'La direcciión debe tener una longitud mínima de 4'
                        },
                    }
                },
                zipcode: {
                    validators: {
                        notEmpty: {
                            message: 'C.P. requerido'
                        },
                    }
                },
                municipality_id: {
                    validators: {
                        notEmpty: {
                            message: 'Ciudad requerida'
                        },
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                defaultSubmit: new FormValidation.plugins.DefaultSubmit(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        })
    }

    async createPerson(){
        let formData = {
            name: this.state.name,
            rfc: this.state.rfc,
            fiscal_name: this.state.fiscalName,
            address1: this.state.adress,
            zipcode: this.state.zipCode,
            municipality: this.state.municipality,
            person_type:this.state.personType,
            internal_id:this.state.internalId,
            people_id:this.props.peopleId,
            country:5,
            selectedState:this.state.selectedState
        };
        window.blockUI();
        KTUtil.btnWait(KTUtil.getById('btnPublish'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
        if(this.props.route != undefined){
            await axios.post(this.props.route,formData);
            window.location.href = '/company/select';
        }else{
            const res = await axios.post('/persons/register',formData);
            window.location.href = '/'+res.data;
        }
    }

    changeFiscalName(event){
        this.setState({fiscalName:event.target.value});
    }

    changeAdress(event){
        this.setState({adress:event.target.value});
    }

    changeZipcode(event){
        this.setState({zipCode:event.target.value});
    }

    changeName(event){
        this.setState({name:event.target.value});
    }

    getPersonType(personType) {
        if (personType == 1) {
            return 'Individual';
        }
        if (personType == 2) {
            return 'Business Entity';
        }
        return personType;
    }

    changeState(event) {
        this.setState({selectedState:event.target.value});
    }

    render() {
        return (
            <>
            <div id="frm" class="col-12">
            <div className="row justify-content-center text-left">
                <div className="col-sm-6 form-group">
                    <label className="text-left font-weight-bold text-dark-light">Estado</label>
                    <input type="text" id={this.props.state} name={this.props.state}
                    placeholder={this.props.state}
                    value={this.state.selectedState}
                    onChange={this.changeState}
                    className="form-control form-control-solid"
                    />
                </div>
                <div className="col-sm-6 form-group">
                    <label className="text-left font-weight-bold text-dark-light">Ciudad</label>
                    <input id={this.props.city}
                    name="municipality_id"
                    placeholder={this.props.city}
                    onChange={this.changeMunicipality}
                    value={this.state.municipality}
                    className="form-control form-control-solid" required
                    />
                </div>
            </div>
            <div class="row text-left">
                <div class="col-sm-6 form-group">
                    <label for="name" class="text-left font-weight-bold">Nombre</label>
                    <input id="name" type="text" class="form-control form-control-solid" name="name" value={this.state.name} required autofocus onChange={this.changeName}/>
                </div>
                <div class="col-sm-6 form-group">
                    <label for="person_type" class="text-left font-weight-bold">Tipo de Persona</label>
                    <select id="person_type" name="person_type" onChange={this.changePersonType} disabled={this.state.personTypeReadOnly}
                        className="form-control form-control-solid"
                        value={this.state.personType} >
                        <option value="Individual">Individual</option>
                        <option value="Business Entity">Business Entity</option>
                    </select>
                </div>
            </div>
            <div class="row text-left">
                <div class="col-sm-6 form-group">
                    <label for="rfc" class="text-left font-weight-bold">Tax ID</label>
                    <input id="rfc" class="form-control form-control-solid"
                        name="rfc"
                        value={this.state.rfc}
                        readOnly={this.state.rfcReadOnly}
                        onChange={this.changeRFC}
                        maxlength="20"
                    />
                </div>
                <div class="col-sm-6 form-group">
                    <label for="fiscal_name" class="text-left font-weight-bold">
                        {this.state.personType == 'Individual' && 'Nombre Completo' }
                        {this.state.personType != 'Individual' && 'Razón Social ' }
                    </label>
                    <input id="fiscal_name" class="form-control form-control-solid"
                    value={this.state.fiscalName}
                    readOnly={this.state.readOnlyFiscalName}
                    onChange={this.changeFiscalName}
                    name="fiscal_name"/>
                </div>
            </div>
            <div class="row text-left">
                <div class="col-sm-6 form-group">
                    <label for="address1" class="text-left font-weight-bold"> Dirección </label>
                    <input id="address1" class="form-control form-control-solid"
                    value={this.state.adress} onChange={this.changeAdress}
                    name="address1"
                    required />
                </div>
                <div class="col-sm-6 form-group">
                    <label for="zipcode" class="text-left font-weight-bold"> C.P. </label>
                    <input id="zipcode" class="form-control form-control-solid"
                    value={this.state.zipCode} onChange={this.changeZipcode}
                    name="zipcode" />
                </div>
            </div>
            </div>
            <div className="d-flex justify-content-around">
                <button type="button" onClick={()=> {this.validate()}  }
                    className="btn col-sm-2 btn-primary font-weight-bolder mr-2">
                    Crear Cuenta
                </button>
            </div>
            </>
        );
    }
}

export default CompleteInformationUs;

if (document.getElementById('CompleteInformationUs')) {
    ReactDOM.render(<CompleteInformationUs />, document.getElementById('CompleteInformationUs'));
}
